import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium'
import { connect } from 'react-redux'

const styles = {
    overlay: {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        padding: '20px',
        backdropFilter: 'blur(8px)',
        animation: 'fadeIn 0.3s ease-out',
        '@media (max-width: 480px)': {
            padding: '15px',
        },
    },
    modalContainer: {
        background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
        borderRadius: '24px',
        padding: '0',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 32px 64px rgba(0, 0, 0, 0.2)',
        border: '1px solid rgba(255, 255, 255, 0.3)',
        position: 'relative' as const,
        overflow: 'hidden',
        animation: 'scaleIn 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        '@media (max-width: 768px)': {
            maxWidth: '400px',
            margin: '20px',
        },
        '@media (max-width: 480px)': {
            maxWidth: '100%',
            margin: '10px',
        },
    },
    modalContent: {
        padding: '3rem 2.5rem 2.5rem',
        textAlign: 'center' as const,
        '@media (max-width: 768px)': {
            padding: '2.5rem 2rem 2rem',
        },
        '@media (max-width: 480px)': {
            padding: '2rem 1.5rem 1.5rem',
        },
        '@media (max-width: 375px)': {
            padding: '1.5rem 1rem 1rem',
        },
    },
    closeButton: {
        position: 'absolute' as const,
        top: '1rem',
        right: '1.5rem',
        background: 'rgba(101, 87, 255, 0.1)',
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        fontSize: '1.5rem',
        color: '#6557ff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.3s ease',
        fontWeight: 300,
        ':hover': {
            background: 'rgba(101, 87, 255, 0.2)',
            transform: 'rotate(90deg)',
        },
    },
    iconContainer: {
        width: '80px',
        height: '80px',
        background: 'linear-gradient(135deg, #6557ff 0%, #8b3fff 100%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 1.5rem',
        fontSize: '2.5rem',
        boxShadow: '0 8px 24px rgba(101, 87, 255, 0.3)',
        '@media (max-width: 480px)': {
            width: '70px',
            height: '70px',
            fontSize: '2rem',
        },
    },
    title: {
        fontSize: '1.75rem',
        fontWeight: 700,
        color: '#1a1a2e',
        margin: '0 0 1rem 0',
        lineHeight: 1.3,
        letterSpacing: '-0.02em',
        '@media (max-width: 480px)': {
            fontSize: '1.5rem',
        },
    },
    message: {
        fontSize: '1.1rem',
        lineHeight: 1.6,
        color: '#6b6b8a',
        margin: '0 0 2.5rem 0',
        fontWeight: 400,
        '@media (max-width: 480px)': {
            fontSize: '1rem',
        },
    },
    errorContainer: {
        background: 'rgba(255, 71, 87, 0.1)',
        border: '1px solid rgba(255, 71, 87, 0.2)',
        borderRadius: '12px',
        padding: '1rem 1.5rem',
        margin: '0 0 2rem 0',
        animation: 'shake 0.5s ease-in-out',
    },
    errorText: {
        color: '#ff4757',
        fontSize: '1rem',
        fontWeight: 500,
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
    },
    actionButton: {
        background: 'linear-gradient(45deg, #6557ff, #8b3fff)',
        color: 'white',
        border: 'none',
        borderRadius: '14px',
        padding: '1rem 2.5rem',
        fontSize: '1.1rem',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 8px 25px rgba(101, 87, 255, 0.3)',
        letterSpacing: '0.02em',
        textTransform: 'uppercase' as const,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.75rem',
        minWidth: '180px',
        justifyContent: 'center',
        ':hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 12px 35px rgba(101, 87, 255, 0.4)',
        },
        ':active': {
            transform: 'translateY(0)',
        },
        '@media (max-width: 375px)': {
            padding: '0.875rem 2rem',
            fontSize: '1rem',
            minWidth: '160px',
        },
    },
    decorativeElements: {
        position: 'absolute' as const,
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #6557ff, #8b3fff, #aa3fff)',
    },
}

// Global animations
const globalStyles = `
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    
    @keyframes scaleIn {
        from {
            opacity: 0;
            transform: scale(0.9) translateY(20px);
        }
        to {
            opacity: 1;
            transform: scale(1) translateY(0);
        }
    }
    
    @keyframes shake {
        0%, 100% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-5px);
        }
        75% {
            transform: translateX(5px);
        }
    }
    
    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.05);
        }
        100% {
            transform: scale(1);
        }
    }
`

const GLOBAL_STYLE_ID = 'confirm-approval-global-styles'

export class MsgProps extends Tgcc.BaseProps {
    Message1: string
    Error?: string
    onContinue: () => void
}

class _ConfirmApproval extends React.Component<MsgProps, any> {
    private modalRef = React.createRef<HTMLDivElement>()
    private originalBodyOverflow: string | null = null

    componentDidMount() {
        // Ensure global styles are injected once (SSR-safe)
        if (typeof document !== 'undefined') {
            if (!document.getElementById(GLOBAL_STYLE_ID)) {
                const styleElement = document.createElement('style')
                styleElement.id = GLOBAL_STYLE_ID
                styleElement.innerHTML = globalStyles
                document.head.appendChild(styleElement)
            }
            // Lock body scroll when modal is open
            if (document.body.style.overflow !== 'hidden') {
                this.originalBodyOverflow = document.body.style.overflow
                document.body.style.overflow = 'hidden'
            }
        }
        // Add escape key listener
        document.addEventListener('keydown', this.handleKeyDown)
        // Auto-focus modal for accessibility
        if (this.modalRef.current) {
            this.modalRef.current.focus()
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown)
        // Restore body scroll when modal is closed
        if (typeof document !== 'undefined' && this.originalBodyOverflow !== null) {
            document.body.style.overflow = this.originalBodyOverflow
        }
    }

    handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this.close()
        }
    }

    close = () => {
        this.props.dispatch({ type: Tgcc.StateAction.DialogAction, payload: null })
    }

    handleBackdropClick = (event: React.MouseEvent) => {
        if (event.target === event.currentTarget) {
            this.close()
        }
    }

    render() {
        const { Message1, Error } = this.props
        const hasError = !!Error

        return (
            <div 
                style={styles.overlay} 
                onClick={this.handleBackdropClick}
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
            >
                <div 
                    ref={this.modalRef}
                    style={styles.modalContainer}
                    tabIndex={-1}
                >
                    {/* Decorative top bar */}
                    <div style={styles.decorativeElements}></div>
                    
                    <div style={styles.modalContent}>
                        {/* Close button */}
                        <button 
                            key="close-button"
                            style={styles.closeButton}
                            onClick={this.close}
                            aria-label="Close dialog"
                        >
                            &times;
                        </button>

                        {/* Icon */}
                        <div style={styles.iconContainer}>
                            {hasError ? '⚠️' : '📋'}
                        </div>

                        {/* Title */}
                        <h1 id="modal-title" style={styles.title}>
                            {hasError ? 'Action Required' : 'Review Required'}
                        </h1>

                        {/* Error message */}
                        {hasError && (
                            <div style={styles.errorContainer}>
                                <p style={styles.errorText}>
                                    <span>⚠️</span>
                                    {Error}
                                </p>
                            </div>
                        )}

                        {/* Main message */}
                        {Message1 && (
                            <p style={styles.message}>
                                {Message1}
                            </p>
                        )}

                        {/* Action button */}
                        <button 
                            key="action-button"
                            style={styles.actionButton}
                            onClick={this.close}
                            className="hoverBorder"
                        >
                            <span>←</span>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state }
}

export var ConfirmApproval = connect(mapStateToProps)(Radium(_ConfirmApproval))